module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"header":{"time":"Čas","initiator":"Iniciátor","target":"Cíl","details":"Detaily"}},"de":{"header":{"time":"Zeit","initiator":"Initiator","target":"Ziel","details":"Details"}},"es":{"header":{"time":"Hora","initiator":"Iniciador","target":"Objetivo","details":"Detalles"}},"fr":{"header":{"time":"Heure","initiator":"Initiateur","target":"Cible","details":"Détails"}}}')
  delete Component.options._Ctor
}
